import { Currency } from '@nemuru-eng/js-api-client';

import {
  AutomobilePreviousValueFieldName,
  AutomobilePreviousValues,
} from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/types/AutomobileFormFieldName';
import { AutomobileFormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/types/AutomobileFormItem';
import { createEditVehicleLiveSummaryFormatters } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/utils/editVehicleLiveSummaryFormatters';

export type VehiclePreviousValuesItem = Pick<AutomobileFormItem, AutomobilePreviousValueFieldName>;

export class VehiclePreviousValuesMap {
  static toChangedFields(
    initialItem: VehiclePreviousValuesItem,
    currentItem: VehiclePreviousValuesItem,
    currency: Currency,
  ): AutomobilePreviousValues {
    const { formatRegistrationDate, formatPrice } = createEditVehicleLiveSummaryFormatters();

    const formattedValues: [AutomobilePreviousValueFieldName, string, string][] = [
      [
        'registrationDate',
        formatRegistrationDate(initialItem.registrationDate),
        formatRegistrationDate(currentItem.registrationDate),
      ],
      ['price', formatPrice(initialItem.price, currency), formatPrice(currentItem.price, currency)],
    ];

    return Object.fromEntries(
      formattedValues
        .filter(([, initialValue, currentValue]) => initialValue !== currentValue)
        .map(([fieldName, initialValue]) => [fieldName, initialValue]),
    );
  }
}
